import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoMdEye } from "react-icons/io";
import TableColumn from "../../TableColumn/TableColumn";
import api from "../../../services/api";
import TopNav from "../../TopNav/TopNav";
import SideBar from "../../SideBar/SideBar";
import { colors } from "../../../styles/tokens";
const ListRedeems = () => {
  const { offerId } = useParams();
  const navigate = useNavigate();

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("desc");

  const [isLoading, setIsLoading] = useState(true);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("ListCurrentRedeemed")) || 1
  );
  const records = 10;

  // const [locale, setLocale] = useState(navigator.language || "en-US");

  const sortableColumns = ["Date", "Name", "Birth Day", "Gender"];

  const [listCheckIns, setListCheckIns] = useState([]);
  const columns = [
    "Date Redeemed",
    "Name",
    "Birth Day",
    "Gender",
    // "Instagram",
    "Email",
    // "Ratings",
    // "Comments",
  ];

  const actions: any[] = [
    {
      label: <IoMdEye size={30} color={colors.primary} />,
      onClick: (rowData) => {
        navigate(`/users/${rowData?.id}`);
      },
    },
  ];

  useEffect(() => {
    const fetchData = async (page: number) => {
      try {
        const response = await api.get(`offers/search-redeemed-offers/${offerId}`, {
          params: {
            page: page,
            records: records,
            sort_column: sortBy,
            sort: sortDirection,
          },
        });

        const itemsTableColumns = response.data.data.map(
          (redeem: any) => ({
            "Date Redeemed": new Date(redeem.redeemed_at).toISOString().split("T")[0],
            Name: redeem.user_details?.user_name || "--",
            Email: redeem.user_details?.user_email || "--",
            // Instagram: redeem.user_details.instagram ? `@${redeem.user_details.instagram}` : '-',
            id: redeem.user_details?.user_id || "_-",
            'Birth Day': redeem.user_details?.user_birthday || "__",
            Gender: redeem.user_details?.user_gender || "__",
          })
        );

        setListCheckIns(itemsTableColumns);
        setTotalPages(response.data.total);
        setIsLoading(false)
      } catch (error) {
        console.log(error);
        setIsLoading(false)
      }
    };

    fetchData(currentPage);
  }, [sortBy, sortDirection, currentPage]);

  console.log(navigator.language);

  const fetchAllData = async () => {
    try {
      const response = await api.get(`offers/search-redeemed-offers/${offerId}`, {
        params: {
          records: 9999999999,
          sort_column: sortBy,
          sort: sortDirection,
        },
      });

      return response.data.data.map(
        (redeem: any) => ({
          "Date Redeemed": new Date(redeem.redeemed_at).toISOString().split("T")[0],
          "User Id": redeem.user_details.user_id,
          Name: redeem.user_details?.user_name,
          Email: redeem.user_details?.user_email,
          // Instagram: redeem.user_details.instagram ? `@${redeem.user_details.instagram}` : '-',
          'Birth Day': redeem.user_details?.user_birthday,
          Gender: redeem.user_details?.user_gender,
        })
      );
    } catch (error) {
      console.log(`Error fetching all data: ${error}`);
      return [];
    }
  };

  const sortColumnsMapping: { [key: string]: string } = {
    Name: "user_name",
    "Date Redeemed": "redeemed_at",
  };

  const handleSort = (columnName: string) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };

  useEffect(() => {
    const storedPage = localStorage.getItem("ListCurrentRedeemed");

    setCurrentPage(Number(storedPage) || 1);
  }, []);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
    localStorage.setItem("ListCurrentRedeemed", page);
  };

  return (
      <>

        <main>
          <TopNav/>
          <div className="main-container">
            <SideBar/>

            <article
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
            >
              <section className="moderators" style={{width: "100%", maxWidth: "1550px"}}>
                    <TableColumn
                        title="Redeemed"
                        backUrl={"/offers"}
                        columns={columns}
                        data={listCheckIns}
                        actions={actions}
                        sortableColumns={sortableColumns}
                        hasHeader={true}
                        hasExport={true}
                        hasSearch={false}
                        dateColumnKeys={['Date Redeemed']}
                        fetchAllData={fetchAllData}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        records={records}
                        onSort={handleSort}
                        loading={isLoading}
                    />
              </section>
            </article>
          </div>
        </main>
        </>);};

 export default ListRedeems;
